import { IContactResume } from './contact.interface';

export interface IWish {
  id: string;
  name: string;
  status?: TWishStatus;
  description?: string;
  mainPhoto?: string;
  optionalPhotos?: any[];
  notes?: string;
  price?: number | null;
  store?: string | null;
  url?: string | null;
  updatedAt?: string;
  purchaseAmount?: number;
}

export interface IWishCard {
  wish: IWish;
  readOnly?: boolean;
  isLiked?: boolean;
  likes?: number;
  deleteItem?: (id: string) => void;
  likeItem?: (id: string) => void;
  bookItem?: (id: string) => void;
  copyItem?: (id: string) => void;
  shareItem?: (id: string) => void;
  editItem?: any;
  wishPurchased?: boolean;
  allowActions?: boolean;
}

export interface IWishFind extends IWish {
  private: boolean;
  nickname: string;
  wishListId: string;
  contact?: IContactResume;
}

export enum EWishStatus {
  AVAILABLE = 0,
  BOOKED = 1,
  ADQUIRED = 2,
}

export type TWishStatus =
  | EWishStatus.AVAILABLE
  | EWishStatus.BOOKED
  | EWishStatus.ADQUIRED;

export enum EDefaultWishList {
  MY_WISHES = 'Mis deseos',
  RECOMMENDED = 'Recomendaciones',
}

export enum EWishlistVisibility {
  PUBLIC = 0,
  PRIVATE = 1,
}

export type TWishlistVisibility = EWishlistVisibility;

export interface IWishlist {
  id: string;
  name: string;
  isDefault: boolean;
  isPrincipal: boolean;
  visibility: TWishlistVisibility;
  locator: string;
}
